module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Plus-2d5239f9ecf303a9a3bdd299ef67d5f0.svg";